import type { InboxState } from "@/lib/states/global-state"

const VALID_INBOX_STATES = new Set<string>([
	"needs-response",
	"new",
	"open",
	"my",
	"my-snoozed",
	"my-done",
	"my-close-loop",
	"snoozed",
	"done",
	"close-loop",
	"sla-breached",
	"custom-view",
])

// The Agent tabs moved to the Agent page, so a tab saved on one opens New.
const LEGACY_AI_INBOX_TABS = new Set([
	"ai-resolved",
	"ai-escalated",
	"ai-issue-created",
	"agent-resolved",
	"agent-escalated",
	"agent-reviewed",
	"agent-pending",
	"agent-loops-closed",
])

export function migratePersistedInboxState(value: unknown): InboxState {
	if (typeof value !== "string") return "new"
	if (LEGACY_AI_INBOX_TABS.has(value)) return "new"
	if (VALID_INBOX_STATES.has(value)) return value as InboxState
	return "new"
}
